import angular from 'angular';
import ngAnimate from 'angular-animate';
import BooksData from '../../data/BooksData';
import bankReconTemplate from './bankRecon.html';
import './BankRecon.css';
/** reconItems */
import { AccountingFilter, reconItemsComponent } from './reconItems';
/** reconSummary */
import { bankReconSummaryComponent } from './reconSummary';
/** Services */
import { BankReconServiceProvider } from './services/BankReconServices';
/** Data */
import { RunBankStatement } from './data/BankStatement';

export default angular
  .module('csm.books.BankRecon', [
    BooksData,
    'ui.grid',
    'ui.grid.pinning',
    'ui.grid.selection',
    'ui.grid.resizeColumns',
    ngAnimate
  ])

  /*******************************************************************************
   * BankRecon */
  /**
   * recon-info is an optional statement that can be added to the bank recon.
   * the <recon-info> element will hold the text to be displayed.
   *
   * @attr  {object}    model            Report request object model
   * @attr  {object}    list             list of data to be loaded.
   * @attr  {object}    allowDiff        Optional. When true, the reconciliation
   *                                     difference must be zero in order to
   *                                     reconcile the bank statement.
   *******************************************************************************/
  .component('bankRecon', {
    template: bankReconTemplate,
    transclude: {
      'recon-info': '?reconInfo',
      serviceChargeInput: '?serviceChargeInput',
      interestEarnedInput: '?interestEarnedInput'
    },
    bindings: {
      model: '=',
      list: '=',
      allowDiff: '&'
    },
    controller: Controller
  })
  .filter('accounting', AccountingFilter)
  .provider('BankReconService', BankReconServiceProvider)
  .component('reconItems', reconItemsComponent)
  .component('reconSummary', bankReconSummaryComponent)
  .run(RunBankStatement).name;

/*******************************************************************************
 * Controller */
/**
 * @ngdoc     controller
 * @module    csm.books.BankRecon
 * @name      csm.books.BankRecon.controller:csmBankReconController
 * @description
 * Controller for the bank recon page.
 *******************************************************************************/
/* @ngInject */ function Controller($scope, $injector) {
  var $svcs = { $ctrl: this, $globals: {} };
  var $ctrl = $injector.invoke(
    init$ctrl,
    null,
    Object.assign($svcs, { $svcs: $svcs })
  );
  var $globals = $injector.invoke(init$globals, null, $svcs);

  /** Used to alert user when they try to navigate away and changes are not saved. */
  window.unsavedChanges = false;

  $globals.init();
}

/*******************************************************************************
 * init$ctrl */
/**
 * $ctrl property initializer.
 *
 * @param  $svcs  Properties to pass with `$injector.invoke()`.
 *******************************************************************************/
/* @ngInject */ function init$ctrl($ctrl, $injector, $svcs, Tools) {
  Object.assign($ctrl, {
    bankAccts: [], //List of Bank Accounts.
    /*-----------------------------------------------*/
    /* We want to clear fields whenever the bank     */
    /* account switches or when we reconcile         */
    /*                                               */
    /* The clearFields is being set in Globals.clear */
    /*-----------------------------------------------*/
    clearFields: false, //Flag used to clear out serviceFee/interest fields
    diff: NaN,
    difference: {},
    expAccts: [], //List of Expense Accounts
    revAccts: [], //List of Revenue Accounts
    statement: {}, //Statement Object
    statementItems: [],
    valOption: {}, //Works with the Validation
    disableBeginBal: true, //Disables the beginning balance if previous reconciliation exists
    enableBtn: false, //Enables/disables print and view summary buttons
    hideStatementDate: true, //Used to hide/show the beginning balance
    reportFormat: 'PDF', //Sets the report format to print in pdf

    bank: $injector.invoke(bank, null, $svcs),
    cancel: $injector.invoke(cancel, null, $svcs),
    getMinDate: $injector.invoke(getMinDate, null, $svcs),
    printReport: $injector.invoke(printReport, null, $svcs),
    save: $injector.invoke(save, null, $svcs),
    showSummary: $injector.invoke(showSummary, null, $svcs),
    statementDate: $injector.invoke(statementDate, null, $svcs)
  });

  /** Calculates the difference to display. */
  return Object.defineProperty($ctrl, 'diff', {
    get: function () {
      if (!$ctrl.statement.accountID) return 0;

      return Tools.roundMoney(
        $ctrl.statement.endBalance - $ctrl.statement.clearedBalance
      );
    }
  });
}

/*******************************************************************************
 * init$globals */
/**
 * $global service initializer. Sets `$global` in `$svcs` for methods called
 * with `$injector.invoke()` that require `$global`.
 *
 * @param  $svcs  Properties to pass with `$injector.invoke()`.
 *******************************************************************************/
/* @ngInject */ function init$globals($injector, $svcs) {
  return Object.assign($svcs.$globals, {
    currentBank: null, //Selected Bank Account.
    defaultBankAccountID: NaN, //Default Bank Account ID.
    statementList: [], //List of Statements.

    clear: $injector.invoke(clear, null, $svcs),
    initStatement: $injector.invoke(initStatement, null, $svcs),
    init: $injector.invoke(init, null, $svcs),
    loadStatementItems: $injector.invoke(loadStatementItems, null, $svcs),
    loadStatements: $injector.invoke(loadStatements, null, $svcs),
    readyForInput: $injector.invoke(readyForInput, null, $svcs)
  });
}

/*******************************************************************************
 * Controller.bank */
/**
 * Getter/Setter. Gets current bank ID and loads the $globals.initStatement()
 *
 * @param accountID  account ID for the bank account selected.
 *******************************************************************************/
/* @ngInject */ function bank($ctrl, $globals) {
  return function (accountID) {
    if (arguments.length == 0) return $ctrl.currentBank;

    $ctrl.currentBank = accountID;

    if ($ctrl.currentBank) $globals.initStatement();
  };
}

/*******************************************************************************
 * Controller.cancel */
/**
 * Clears the reconciliation in progress. If saved previously, the
 * reconciliation will be removed.
 *******************************************************************************/
/* @ngInject */ function cancel(
  $ctrl,
  $globals,
  Alert,
  BankReconService,
  BusyScreen
) {
  return function () {
    Alert.confirm(
      'Are you sure want to cancel this reconciliation?',
      'Confirm Cancel'
    ).then(function () {
      $ctrl.currentBank = null;

      if (!$ctrl.statement.id) $globals.clear();
      /*---------------------------------------------*/
      /* Removes the previously reconciled statement */
      /*---------------------------------------------*/ else
        BusyScreen.promise(
          BankReconService.dropStatement($ctrl.statement.id).then(
            $globals.readyForInput,
            function (resp) {
              Alert.error(
                resp.parsedResponse
                  ? resp.parsedResponse.message()
                  : resp.statusText
              );
            }
          )
        );
    });
  };
}

/*******************************************************************************
 * Globals.clear */
/**
 * Resets values on page loads
 *******************************************************************************/
/* @ngInject */ function clear($ctrl, $globals, Alert, BooksData) {
  return function () {
    $ctrl.difference = {};
    $ctrl.statement = new BooksData.BankStatement();
    $ctrl.statementItems = [];
    $ctrl.enableBtn = false;
    $ctrl.hideStatementDate = true;
    $ctrl.clearFields = true;
    Alert.clear();
    $globals.loadStatementItems();
    $ctrl.valOption.reset();
    window.unsavedChanges = false;
  };
}

/*******************************************************************************
 * Controller.getMinDate */
/**
 * Returns the next day from the previous statement date to be used with
 * validating the current statement date.
 *
 * @return  Minimum statement date
 *******************************************************************************/
/* @ngInject */ function getMinDate($ctrl) {
  return function () {
    if (!$ctrl.lastStmtDate) return null;

    var d = new Date($ctrl.lastStmtDate);
    d.setDate(d.getDate() + 1);
    return d;
  };
}

/*******************************************************************************
 * Globals.init */
/**
 * Initializes the application by loading static data and getting the existing
 * statements.
 *******************************************************************************/
/* @ngInject */ function init(
  $ctrl,
  $globals,
  $q,
  BooksSvc,
  BusyScreen,
  SERVER
) {
  return function () {
    BusyScreen.setBusy(true);

    $q.all([
      BooksSvc.getOrganization().then(function (resp) {
        $globals.defaultBankAccountID = resp.data.defaultBankID;
      }),
      BooksSvc.viewChartOfAccounts().then(function (resp) {
        var coa = resp.data;
        for (var i = 0; i < coa.length; i++) {
          if (
            coa[i].accountClass == SERVER.BooksDBConstants.AC_REVENUE ||
            coa[i].type == 'Trust'
          )
            $ctrl.revAccts.push(coa[i]);

          if (
            coa[i].accountClass == SERVER.BooksDBConstants.AC_EXPENSE ||
            coa[i].type == 'Trust'
          )
            $ctrl.expAccts.push(coa[i]);

          if (coa[i].type == 'Bank') $ctrl.bankAccts.push(coa[i]);
        }
      })
    ]).then($globals.readyForInput);
  };
}

/*******************************************************************************
 * Globals.initStatement */
/**
 * Loads the initial statement to display
 *******************************************************************************/
/* @ngInject */ function initStatement(
  $ctrl,
  $globals,
  $q,
  BankReconService,
  BooksData,
  BusyScreen
) {
  return function () {
    $globals.clear();

    /*---------------------------------------------------*/
    /* Account information for the selected bank account */
    /*---------------------------------------------------*/
    var statements = $globals.statementList.filter(function (bs) {
      return bs.accountID == $ctrl.currentBank;
    });

    /*--------------------------------------------*/
    /* Information for bank account selected      */
    /* when previously saved, but not reconciled. */
    /*--------------------------------------------*/
    var previous = statements
      .filter(function (bs) {
        return bs.reconciled;
      })
      .shift();

    /*-------------------------------------------------------*/
    /* Set properties based on previous reconciled statement */
    /*-------------------------------------------------------*/
    $ctrl.disableBeginBal = !!previous;
    $ctrl.lastStmtDate = previous ? previous.entryDate : null;
    $ctrl.hideStatementDate = !previous;

    /*----------------------------------------*/
    /* Set up the statement to work with from */
    /* a saved reconciliation if available.   */
    /*----------------------------------------*/
    var inProgress = statements
      .filter(function (bs) {
        return !bs.reconciled;
      })
      .shift();

    /*----------------------------*/
    /* Load the recon in progress */
    /*----------------------------*/
    if (inProgress) {
      var defer = $q.defer();
      BusyScreen.setBusy(true);
      $ctrl.hideStatementDate = previous ? false : true;
      BankReconService.getStatement(inProgress.id).then(function (data) {
        BusyScreen.setBusy(false);
        $ctrl.statement = new BooksData.BankStatement(data);
        $ctrl.lastStmtDate = previous ? previous.entryDate : null;

        if ($ctrl.statement.difference)
          $ctrl.difference = $ctrl.statement.difference;

        $globals.loadStatementItems().then(defer.resolve);
      });
      return defer.promise;
    } else {
      /*---------------------------------*/
      /* Otherwise start a new statement */
      /*---------------------------------*/
      $ctrl.statement = new BooksData.BankStatement({
        accountID: $ctrl.currentBank,
        begBalance: previous ? previous.endBalance : 0
      });

      return $q.resolve();
    }
  };
}

/*******************************************************************************
 * Globals.loadStatementItems */
/**
 * Gets an array of statement items and separates them out in to checks and
 * deposits.
 *
 * @return returns a promise of the items in the statement to be displayed in
 *         the grids
 *******************************************************************************/
/* @ngInject */ function loadStatementItems(
  $ctrl,
  $q,
  Alert,
  BankReconService,
  BusyScreen
) {
  return function () {
    var defer = $q.defer();

    if (!$ctrl.statement.accountID) return defer.promise;

    BusyScreen.setBusy(true);
    BankReconService.getStatementItems(
      $ctrl.statement.accountID,
      $ctrl.statement.entryDate,
      $ctrl.statement.id
    ).then(
      function (data) {
        $ctrl.statementItems = data || [];
        $ctrl.statement.setItems($ctrl.statementItems);

        BusyScreen.setBusy(false);
        defer.resolve();
      },
      function (resp) {
        Alert.error(
          resp.parsedResponse ? resp.parsedResponse.message() : resp.statusText,
          'Reconciliation Failed'
        );
        BusyScreen.setBusy(false);
      }
    );
    $ctrl.enableBtn = true;
    return defer.promise;
  };
}

/*******************************************************************************
 * Gloabls.loadStatements */
/**
 * Loads statements for the selected bank account.
 *
 * @return    promise array of all statements for the organization
 *******************************************************************************/
/* @ngInject */ function loadStatements($globals, BankReconService) {
  return function () {
    return BankReconService.getStatementList().then(function (data) {
      $globals.statementList = data;
    });
  };
}

/*****************************************************************************
 * Controller.printReport */
/**
 * Prints the list of transactions shown in the grid once a bank account and date
 * are selected. Unclearable items do not show in the report since they can not
 * be cleared.
 *****************************************************************************/
/* @ngInject */ function printReport($ctrl, $filter) {
  return function () {
    window.open(
      'ReconItemList.aspx?rt={0}&bid={1}&sd={2}'.format(
        $ctrl.reportFormat,
        $ctrl.currentBank,
        $filter('date')($ctrl.statement.entryDate, 'MM/dd/yyyy')
      ),
      '_blank'
    );
  };
}

/*******************************************************************************
 * Globals.readyForInput */
/**
 * Prepare the UI for user interaction by loading all statements and setting
 * the default bank account.
 *******************************************************************************/
/* @ngInject */ function readyForInput($ctrl, $globals, BusyScreen) {
  return function () {
    return $globals.loadStatements().then(function () {
      $globals.clear();
      BusyScreen.setBusy(false);

      /*---------------------------------*/
      /* Initialize the bank account ID. */
      /*---------------------------------*/
      $ctrl.bank($globals.defaultBankAccountID);
    });
  };
}

/*****************************************************************************
 * Controller.save */
/**
 * Saves the current state of the reconciliation. If reconcile is true, then
 * the statement will be reconciled. A difference adjustment item will be
 * created if allowed and requested.
 *
 * @param reconcile  Indication that the save is for reconciling
 *****************************************************************************/
/* @ngInject */ function save(
  $ctrl,
  $globals,
  $filter,
  $q,
  Alert,
  BankReconService,
  BusyScreen,
  Session
) {
  return function (reconcile) {
    if (!$ctrl.valOption.validate()) return;

    $ctrl.difference.amount = $ctrl.diff;

    if (reconcile && !$ctrl.allowDiff() && $ctrl.diff) {
      /*-----------------------------------------------*/
      /* Message currently used for PTA that the       */
      /* difference must be zero in order to reconcile */
      /*-----------------------------------------------*/
      Alert.info(
        'Reconciliation difference must be zero in order to reconcile',
        'Reconciliation'
      );
      return;
    }

    $q.when(
      (function () {
        Alert.clear();
        if (!reconcile) return true;

        var defer = $q.defer();

        /*----------------------------------------------------------------*/
        /* Confirm reconciliation message. Alerts that there is a         */
        /* difference and prompts for verification that user would like   */
        /* to proceed before making an entry for the difference, or if    */
        /* no difference, just confirms that the user wants to reconcile. */
        /*----------------------------------------------------------------*/
        var msg = $ctrl.diff
          ? 'You have a difference of ' +
            $filter('currency')($ctrl.diff) +
            '.\nWould you like to continue with this reconciliation?'
          : 'Are you sure you wish to continue with this reconciliation?';

        Alert.confirm(msg, 'Reconciliation Confirmation').then(function () {
          /*-------------------------------------------*/
          /* Create a difference recon item if needed. */
          /*-------------------------------------------*/
          $ctrl.statement.difference = { amount: $ctrl.diff };

          defer.resolve();
        });
        return defer.promise;
      })()
    ).then(function () {
      /*-----------------------------------------------------------*/
      /* Sets the properties to be submitted on the reconciliation */
      /*-----------------------------------------------------------*/
      $ctrl.statement.reconciled = reconcile;
      $ctrl.statement.difference =
        reconcile && $ctrl.difference.amount != 0 ? $ctrl.difference : null;
      $ctrl.statement.interest =
        $ctrl.statement.interest && $ctrl.statement.interest.amount > 0
          ? $ctrl.statement.interest
          : null;
      $ctrl.statement.serviceFee =
        $ctrl.statement.serviceFee && $ctrl.statement.serviceFee.amount > 0
          ? $ctrl.statement.serviceFee
          : null;
      $ctrl.statement.journalIDs = $ctrl.statementItems
        .filter(function (bi) {
          return bi.cleared;
        })
        .map(function (bi) {
          return bi.journalID;
        });

      BusyScreen.setBusy(true);

      /*--------------------------*/
      /* Saves the reconciliation */
      /*--------------------------*/
      BankReconService.saveStatement($ctrl.statement)
        .then(
          function (data) {
            var statementID = data;
            $globals.loadStatements().then(function () {
              $ctrl.currentBank = $ctrl.statement.accountID;
              $globals.initStatement().then(function () {
                /*---------------------------------------------------------*/
                /* Save only, saves the reconciliation and reloads it.     */
                /* Allows user to come back later to finish reconciliation */
                /*---------------------------------------------------------*/
                if (!reconcile) {
                  Alert.success(
                    'Your reconciliation has been saved',
                    'Save Success'
                  );
                  $globals.loadStatementItems();
                } else
                  /*-------------------------------------------*/
                  /* Otherwise, prompt to print reconciliation */
                  /*-------------------------------------------*/
                  Alert.confirm(
                    'Your statement has been reconciled.\nWould you like to print the\ndetailed summary report?',
                    'Reconciliation Success'
                  ).then(function () {
                    window.open(
                      Session.getSessionURL(
                        '/BankReconReport.aspx?sid=' +
                          statementID +
                          '&ind=true&rt=PDF'
                      ),
                      '_blank'
                    );
                  });
              });
            });
          },
          function (resp) {
            /*-------------------------------------*/
            /* Save failed, clear reconciled flag. */
            /*-------------------------------------*/
            $ctrl.statement.reconciled = false;

            Alert.error(
              resp.parsedResponse
                ? resp.parsedResponse.message()
                : resp.statusText
            );
          }
        )
        .finally(function () {
          BusyScreen.setBusy(false);
        });
    });
  };
}

/*****************************************************************************
 * Controller.showSummary */
/**
 * Display a modal with the summary information for the current statement input
 *****************************************************************************/
/* @ngInject */ function showSummary($ctrl, $uibModal) {
  return function () {
    /*-----------------------------------------------------------*/
    /* Set the statement items before we open the modal so that  */
    /* the modal can calculate the cleared and uncleared totals. */
    /*-----------------------------------------------------------*/
    $ctrl.statement.setItems($ctrl.statementItems);

    $uibModal.open({
      size: 'lg',
      template:
        '<div class="modal-header" >' +
        '  <h3 class="modal-title">Reconciliation Summary</h3>' +
        '</div>' +
        '<div class="modal-body">' +
        '  <recon-summary statement="statement""></recon-summary>' +
        '</div>' +
        '<!------------------------------>' +
        '<!-- Footer with close button -->' +
        '<!------------------------------>' +
        '<div class="modal-footer" style="text-align:center">' +
        '  <button class="btn btn-info" type="button" ng-click="$dismiss()">Close</button>' +
        '</div>',
      controller: function ($scope) {
        $scope.statement = $ctrl.statement;
      }
    });
  };
}

/*****************************************************************************
 * Controller.statementDate */
/**
 * Compares the date of the last statement date to the date entered by the user
 * and also compares the date entered by the user to the current date.
 * If the date entered is not later than the last statement date or is later than
 * the current date data will not load in the grids.
 *
 * @param date  Date entered by the user
 *****************************************************************************/
/* @ngInject */ function statementDate($ctrl, $globals, Alert) {
  return function (date) {
    if (!arguments.length)
      return $ctrl.statement ? $ctrl.statement.entryDate : null;

    if (!$ctrl.statement) return;

    $ctrl.statement.entryDate = angular.isDate(date) ? date : null;
    window.unsavedChanges = true;

    if (!$ctrl.statement.entryDate) return;

    /*---------------------------------------------------*/
    /* If the statement date is later than today's date, */
    /* alert is sent and statement items do not load.    */
    /*---------------------------------------------------*/
    if (date > new Date()) {
      Alert.info(
        "Statement Date can not be later than today's date",
        'Statement Date'
      );
      return;
    }
    /*----------------------------------------------------------*/
    /* If the statement date is earlier that the last statement */
    /* date, Alert is sent and the statement items do not load  */
    /*----------------------------------------------------------*/
    if ($ctrl.disableBeginBal)
      if ($ctrl.lastStmtDate >= $ctrl.statement.entryDate) {
        Alert.info(
          'Statement Date must be later than ' +
            $ctrl.lastStmtDate.toLocaleDateString(),
          'Statement Date'
        );
        return;
      }

    if ($ctrl.statement.accountID) $globals.loadStatementItems();
  };
}
